import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import WorkIcon from '@mui/icons-material/Work';

import { UI } from '../../';
import { useAppState } from '../../../Context/AppStateContext';
import { JobAnalyzer } from '../../job-analysis';
import { theme } from '../../../theme';

const { Modal } = UI;

interface JobAnalysisProps {
  visible: boolean;
  onClose: () => void;
  onFocus: () => void;
  isActive?: boolean;
}

const JobAnalysisContainer = styled.div`
  padding: 20px;
  color: ${theme.colors.green};
  font-family: 'Courier New', monospace;
  font-size: 13px;
  line-height: 1.4;
  
  .job-analyzer {
    .form-group label {
      display: block;
      margin-bottom: 8px;
      font-weight: bold;
      color: ${theme.colors.green};
    }
    
    textarea {
      background-color: rgba(0, 0, 0, 0.8);
      color: ${theme.colors.green};
      border: 1px solid ${theme.colors.green};
      font-family: 'Courier New', monospace;
      
      &:focus {
        outline: none;
        border-color: ${theme.colors.primaryHover};
        box-shadow: 0 0 5px rgba(31, 207, 94, 0.3);
      }
      
      &::placeholder {
        color: rgba(31, 207, 94, 0.6);
      }
    }
    
    button {
      background-color: ${theme.colors.green};
      color: ${theme.colors.background};
      border: 1px solid ${theme.colors.green};
      font-family: 'Courier New', monospace;
      font-weight: bold;
      
      &:hover:not(:disabled) {
        background-color: ${theme.colors.primaryHover};
        border-color: ${theme.colors.primaryHover};
      }
      
      &:disabled {
        background-color: rgba(31, 207, 94, 0.3);
        color: rgba(0, 0, 0, 0.5);
        cursor: not-allowed;
      }
    }
    
    .error-message {
      background-color: rgba(255, 0, 0, 0.1);
      border: 1px solid rgba(255, 0, 0, 0.3);
      color: #ff6b6b;
    }
    
    .analysis-result {
      background-color: rgba(31, 207, 94, 0.1);
      border: 1px solid rgba(31, 207, 94, 0.3);
      color: ${theme.colors.green};
      
      h3 {
        color: ${theme.colors.primaryHover};
        margin-bottom: 16px;
      }
      
      strong {
        color: ${theme.colors.primaryHover};
      }
      
      p {
        color: ${theme.colors.green};
        margin: 8px 0;
      }
    }
  }
`;

const JobAnalysis: React.FC<JobAnalysisProps> = ({ visible, onClose, onFocus, isActive }) => {
  const { t } = useTranslation();
  const { isOnMobile } = useAppState();

  if (!visible) return null;

  return (
    <Modal
      color={theme.colors.green}
      header={t('modals.jobAnalysis.header')}
      widthString={isOnMobile ? '95%' : '800px'}
      xPositionPercent={isOnMobile ? 50 : 50}
      yPositionPercent={20}
      onClose={onClose}
      onFocus={onFocus}
      isActive={isActive}
      icon={<WorkIcon />}
    >
      <JobAnalysisContainer>
        <JobAnalyzer
          onAnalysisComplete={(result) => {
            console.log('Job analysis completed:', result);
          }}
        />
      </JobAnalysisContainer>
    </Modal>
  );
};

export default JobAnalysis;